export enum FeeCalculationType {
	NotSet = 0,
	FixedAmount = 1,
	Percentage = 2
}
